export const OA_ID = '@mmchic';
export const OA_CHAT = `https://line.me/R/oaMessage/${encodeURIComponent(OA_ID)}`;
export const OA_PROFILE = `https://line.me/R/ti/p/${encodeURIComponent(OA_ID)}`;
export const MAX_PREFILL_URL = 1800;

export function orderText(cart, lang = 'en') {
  if (!cart.items?.length) throw new Error('empty');
  const th = lang === 'th';
  const lines = [th ? 'สอบถามสั่งซื้อ MMCHIC' : 'MMCHIC order enquiry'];
  cart.items.forEach((item, index) => {
    const options = (item.options_with_values || []).filter(o => o.value !== 'Default Title')
      .map(o => `${o.name}: ${o.value}`).join(' / ');
    lines.push('', `${index + 1}. ${item.product_title || item.title}`);
    if (options) lines.push(options);
    else if (item.variant_title && item.variant_title !== 'Default Title') lines.push(item.variant_title);
    if (item.sku) lines.push(`SKU: ${item.sku}`);
    lines.push(`${th ? 'จำนวน' : 'Quantity'}: ${item.quantity}`);
    lines.push(`https://mmchicbangkok.com/products/${encodeURIComponent(item.handle)}?variant=${item.variant_id}`);
  });
  lines.push('', th ? 'กรุณาให้แอดมินตรวจสต็อก ไซซ์ ค่าส่ง ส่วนลด และคำนวณยอดชำระสุดท้ายก่อนชำระเงิน' :
    'Please ask our team to confirm stock, sizes, shipping, discounts and calculate the final payment amount before payment.');
  lines.push(th ? 'รายการนี้ยังไม่ใช่ออเดอร์ที่ยืนยัน และยังไม่ได้สำรองสินค้า' : 'This enquiry is not a confirmed order and does not reserve stock.');
  return lines.join('\n');
}

export function imagePages(cart, lang = 'en') {
  if (!cart.items?.length) throw new Error('empty');
  const pages = [];
  for (let i = 0; i < cart.items.length; i += 4) {
    pages.push(cart.items.slice(i, i + 4).map(item => {
      if (!item.image) throw new Error('missing-image');
      const options = (item.options_with_values || []).filter(o => o.value !== 'Default Title')
        .map(o => `${o.name}: ${o.value}`).join(' / ') ||
        (item.variant_title !== 'Default Title' ? item.variant_title : '') || '';
      return { title: item.product_title || item.title, sku: item.sku || '', options,
        quantity: item.quantity, image: item.image, link: `https://mmchicbangkok.com/products/${encodeURIComponent(item.handle)}?variant=${item.variant_id}` };
    }));
  }
  return pages;
}

function wrapped(ctx, value, x, y, maxWidth, lineHeight, maxLines = 2) {
  const graphemes = typeof Intl.Segmenter === 'function'
    ? [...new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(String(value || ''))].map(s => s.segment)
    : Array.from(String(value || ''));
  let line = '', used = 0;
  for (const char of graphemes) {
    if (ctx.measureText(line + char).width > maxWidth && line) {
      if (used >= maxLines - 1) throw new Error('card-too-long');
      ctx.fillText(line.trim(), x, y + used * lineHeight); used++; line = char.trimStart();
    } else line += char;
  }
  if (line) ctx.fillText(line.trim(), x, y + used * lineHeight);
}

async function loadProductImage(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error('image-unavailable'));
    const source = new URL(url, location.href);
    if (source.hostname === 'cdn.shopify.com') source.searchParams.set('width', '250');
    if (source.origin !== location.origin) img.crossOrigin = 'anonymous';
    img.src = source.href;
  });
}

export async function orderImageBlobs(cart, lang = 'en') {
  const pages = imagePages(cart, lang);
  const th = lang === 'th';
  const blobs = [];
  for (let p = 0; p < pages.length; p++) {
    const images = await Promise.all(pages[p].map(row => loadProductImage(row.image)));
    const canvas = document.createElement('canvas');
    canvas.width = 1080; canvas.height = 320 + pages[p].length * 265;
    const c = canvas.getContext('2d');
    c.fillStyle = '#fff'; c.fillRect(0, 0, canvas.width, canvas.height);
    c.fillStyle = '#1a1a1a'; c.font = 'bold 57px sans-serif'; c.fillText('MMCHIC', 55, 92);
    c.font = '28px sans-serif'; c.fillText(th ? 'รายการสินค้าที่ต้องการสอบถาม' : 'Items for enquiry', 55, 140);
    c.font = '22px sans-serif'; c.fillText(`${p + 1} / ${pages.length}`, 960, 140);
    c.fillStyle = '#777'; c.fillRect(55, 170, 970, 2);
    for (let i = 0; i < pages[p].length; i++) {
      const row = pages[p][i], img = images[i], top = 195 + i * 265;
      const scale = Math.min(190 / img.naturalWidth, 210 / img.naturalHeight);
      const w = img.naturalWidth * scale, h = img.naturalHeight * scale;
      c.drawImage(img, 55 + (190 - w) / 2, top + (210 - h) / 2, w, h);
      c.fillStyle = '#1a1a1a'; c.font = 'bold 28px sans-serif'; wrapped(c, row.title, 280, top + 38, 720, 34, 3);
      c.font = '24px sans-serif';
      wrapped(c, row.options, 280, top + 148, 720, 30, 2);
      c.fillText(`SKU: ${row.sku || '—'}    ${th ? 'จำนวน' : 'Qty'}: ${row.quantity}`, 280, top + 215);
      c.fillStyle = '#ddd'; c.fillRect(55, top + 250, 970, 1);
    }
    c.fillStyle = '#1a1a1a'; c.font = '24px sans-serif';
    c.fillText(th ? 'ให้แอดมินยืนยันสินค้าและคำนวณยอดชำระสุดท้าย' :
      'Our team will confirm items and calculate the final payment.', 55, canvas.height - 65);
    c.font = '20px sans-serif'; c.fillText('LINE @mmchic · mmchicbangkok.com', 55, canvas.height - 28);
    const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
    if (!blob) throw new Error('image-unavailable');
    blobs.push(blob);
  }
  return blobs;
}

export function prefillURL(text, mobile) {
  const url = `${OA_CHAT}/?${encodeURIComponent(text)}`;
  return mobile && url.length <= MAX_PREFILL_URL ? url : null;
}

export async function loadOrder(root, fetcher = fetch, cartRows = null) {
  const get = async path => {
    const response = await fetcher(`${root}${path}`, { cache: 'no-store', credentials: 'same-origin', signal: AbortSignal.timeout(10000) });
    if (!response.ok) throw new Error('network');
    return response.json();
  };
  const cart = await get('cart.js');
  if (!cart.items?.length) throw new Error('empty');
  if (cartRows) {
    const rows = new Map(cartRows.map(row => [row.key, row]));
    if (cart.items.every(item => rows.has(item.key) && typeof rows.get(item.key).available === 'boolean')) {
      return {
        cart: { ...cart, items: cart.items.map(item => ({
          ...item,
          image: rows.get(item.key).image || item.image,
        })) },
        unavailable: cart.items.filter(item => !rows.get(item.key).available),
      };
    }
  }
  const handles = [...new Set(cart.items.map(i => i.handle))];
  const products = new Map();
  for (let index = 0; index < handles.length; index += 4) {
    await Promise.all(handles.slice(index, index + 4).map(async handle => {
      products.set(handle, await get(`products/${encodeURIComponent(handle)}.js`));
    }));
  }
  const unavailable = cart.items.filter(item => !products.get(item.handle)?.variants?.some(
    variant => String(variant.id) === String(item.variant_id) && variant.available === true
  ));
  return { cart, unavailable };
}

export function imageFiles(blobs, FileClass = File) {
  return blobs.map((blob, index) => new FileClass([blob], `MMCHIC-list-${index + 1}-of-${blobs.length}.png`, { type: 'image/png' }));
}

if (typeof document !== 'undefined') {
  const configNode = document.querySelector('[data-mm-line-config]');
  if (configNode) {
    const config = JSON.parse(configNode.textContent);
    const pending = new Set();
    let version = 0;
    let lastEdit = 0;
    let prepared = null;
    let preparing = false;
    let scheduled = null;
    let shareBroken = false;

    const buttons = () => document.querySelectorAll('[data-mm-cart-image], [data-mm-line-order]');
    const setStatus = message => {
      document.querySelectorAll('[data-mm-order-status]').forEach(node => { node.textContent = message; });
    };
    const setEnabled = enabled => {
      buttons().forEach(button => { button.disabled = !enabled; });
    };
    const hasButtons = () => Boolean(document.querySelector('[data-mm-cart-image], [data-mm-line-order]'));
    const cartRows = () => [...document.querySelectorAll('.cart-items__table-row[data-key]')].map(row => ({
      key: row.dataset.key,
      available: row.hasAttribute('data-mm-variant-available') ? row.dataset.mmVariantAvailable === 'true' : null,
      image: row.dataset.mmImageUrl || '',
    }));
    const invalidate = () => {
      version++;
      prepared = null;
      setEnabled(false);
      setStatus(config.changed);
    };
    const prepare = async () => {
      if (!hasButtons() || preparing) return;
      preparing = true;
      const current = ++version;
      prepared = null;
      setEnabled(false);
      setStatus(config.loading);
      try {
        const started = Date.now();
        while (pending.size || Date.now() - lastEdit < 450 || document.querySelector('.cart-items-disabled')) {
          if (Date.now() - started > 12000) throw new Error('network');
          await new Promise(resolve => setTimeout(resolve, 100));
          if (current !== version) return;
        }
        const result = await loadOrder(window.Shopify?.routes?.root || '/', fetch, cartRows());
        if (current !== version) return;
        if (result.unavailable.length) {
          setStatus(`${config.unavailable} ${result.unavailable.map(i => `${i.product_title} (${i.variant_title || i.sku || i.variant_id})`).join(', ')}`);
          return;
        }
        setStatus(config.imageLoading);
        const blobs = await orderImageBlobs(result.cart, config.lang);
        if (current !== version) return;
        prepared = { blobs };
        setEnabled(true);
        setStatus(config.ready);
      } catch (error) {
        if (current === version) {
          setStatus(error.message === 'empty' ? config.empty : error.message === 'missing-image' ? config.imageMissing : config.error);
        }
      } finally {
        preparing = false;
        if (current !== version && hasButtons()) schedulePrepare();
      }
    };
    const schedulePrepare = () => {
      if (scheduled) clearTimeout(scheduled);
      scheduled = setTimeout(() => { scheduled = null; prepare(); }, 80);
    };
    const download = blobs => {
      blobs.forEach((blob, index) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `MMCHIC-list-${index + 1}-of-${blobs.length}.png`;
        document.body.append(a);
        a.click();
        a.remove();
        setTimeout(() => URL.revokeObjectURL(url), 60000);
      });
    };
    document.addEventListener('click', event => {
      const button = event.target.closest('[data-mm-cart-image], [data-mm-line-order]');
      if (!button || button.disabled || !prepared) return;
      if (button.matches('[data-mm-cart-image]')) {
        download(prepared.blobs);
        setStatus(config.imageSaved);
        return;
      }
      let files;
      try { files = imageFiles(prepared.blobs); } catch { files = null; }
      let shareable = false;
      try { shareable = Boolean(!shareBroken && files && navigator.canShare?.({ files }) && navigator.share); } catch { shareable = false; }
      if (shareable) {
        try {
          const sharing = navigator.share({ files, title: 'MMCHIC' });
          setStatus(config.sharePrompt);
          Promise.resolve(sharing).catch(error => {
            if (error.name !== 'AbortError') shareBroken = true;
            setStatus(error.name === 'AbortError' ? config.shareCancelled : config.shareError);
          });
          return;
        } catch (error) {
          if (error.name === 'AbortError') { setStatus(config.shareCancelled); return; }
          shareBroken = true;
        }
      }
      download(prepared.blobs);
      setStatus(config.shareFallback);
      window.open(OA_PROFILE, '_blank', 'noopener,noreferrer');
    });
    document.addEventListener('cart:update', () => { invalidate(); schedulePrepare(); });
    for (const eventName of ['shopify:cart:lines-update', 'shopify:cart:discount-update']) {
      document.addEventListener(eventName, event => {
        lastEdit = Date.now();
        invalidate();
        if (event.promise) {
          pending.add(event.promise);
          event.promise.catch(() => {}).finally(() => { pending.delete(event.promise); schedulePrepare(); });
        } else schedulePrepare();
      });
    }
    document.addEventListener('quantity-selector:update', () => {
      lastEdit = Date.now(); invalidate(); schedulePrepare();
    });
    document.addEventListener('change', event => {
      if (event.target.closest('cart-items-component')) {
        lastEdit = Date.now(); invalidate(); schedulePrepare();
      }
    }, true);
    window.addEventListener('pageshow', () => { invalidate(); schedulePrepare(); });
    window.addEventListener('focus', () => { if (hasButtons()) { invalidate(); schedulePrepare(); } });
    new MutationObserver(() => {
      if (hasButtons()) {
        setEnabled(Boolean(prepared));
        if (!prepared && !preparing && !scheduled) schedulePrepare();
      }
    }).observe(document.body, { childList: true, subtree: true });
    schedulePrepare();
  }
}
